<ng-container *ngrxLet="loadingSequenceTab$; let loading">
  @if (tableRows && tableRows.length > 0 && !loading) {
    <ng-container *ngrxLet="currentVtc$; let currentVtc">
      <p-table
        tableStyleClass="detail-table"
        scrollHeight="var(--tab-scroll-height)"
        [scrollable]="true"
        responsiveLayout="scroll"
        [value]="tableRows"
        selectionMode="single"
        >
        <ng-template pTemplate="header">
          <tr>
            @for (h of tableHeader; track h) {
              <th class="{{ h.scssClass }}" [attr.aria-label]="h.value ? h.value : h.offscreenHeader">@if (h.value) {
                <span class="h-offscreen">Spaltentitel</span>
                }{{ h.value }}@if (!h.value) {
                <span class="h-offscreen">Spaltentitel {{h.offscreenHeader}}</span>
              }</th>
            }
            @if (!readonly) {
              <th class="action-header" pFrozenColumn alignFrozen="right" aria-label="Tabellen Aktionen">
                <span class="h-offscreen">Spaltentitel Tabellen Aktionen</span>
              </th>
            }
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-sequence let-i="rowIndex">
          <ng-template #constraintsTooltipTemplate>
            <app-restriction-tooltip [restrictions]="sequence.rightsRestrictions"></app-restriction-tooltip>
          </ng-template>
          <tr
            [appHighlightRow]="i"
            (highlightedRowChanged)="highlightedRowIndex = $event"
            (click)="navigateToSequence(sequence)"
            (mouseenter)="setHoveredTimeFrame(sequence)"
            (mouseleave)="clearHoveredTimeFrame()"
            class="table-row details-table-row"
            [ngClass]="{ 'active-sequence-transcript-subtitle': sequence.sequenceId === activeSequenceId }"
            data-cy="details-table-row"
            >
            <td class="details-table-shot media-column" data-cy="details-table-shot">
              <img
                                [src]="
                                    ($any(sequence.keyframeBlob$ | async) | blobToObjectURL) ??
                                    'assets/images/empty-keyframe.svg'
                                "
                alt="Sequenz {{ i + 1 }}"
                />
                @if (highlightedRowIndex === i) {
                  <div class="table-entry-number">{{ i + 1 }}</div>
                }
                <div class="h-offscreen">
                  Laufzeit {{ getAccessibilityDurationString(sequence.duration) }}
                </div>
                <div class="duration" aria-hidden="true">
                  {{ sequence.duration ? (sequence.duration | durationFormatPipe) : "-" }}
                </div>
              </td>
              <td class="details-table-place">
                <app-highlight [text]='sequence.country' [keywords]='keywords'></app-highlight>
                <br />
                <app-highlight [text]='sequence.location' [keywords]='keywords'></app-highlight>
              </td>
              <td class="details-table-description">
                <app-highlight [text]='sequence.description' [keywords]='keywords'></app-highlight>
              </td>
              <td class="details-table-value">
                @if (sequence.rating) {
                  <img src="assets/icons/diamond.svg" alt="Wertigkeit" pTooltip="{{ sequence.rating }}" />
                }
              </td>
              <td class="details-table-usage">
                @if (showConstraintTooltipLink(sequence.rightsRestrictions)) {
                  <span
                    [pTooltip]="constraintsTooltipTemplate"
                    tooltipStyleClass="tooltip"
                    [escape]="false"
                    tooltipPosition="left"
                    >Rechte beachten!</span
                    >
                }
              </td>
              @if (!readonly) {
                <td class="action-icon-td" (click)="showActions($event, i)" pFrozenColumn alignFrozen="right">
                  @if (highlightedRowIndex !== i) {
                    <button
                      type="button"
                      class="p-table-icon-button"
                      (click)="showActions($event, i)"
                      >
                      <img src="assets/icons/ellipsis.svg" alt="Optionen" />
                    </button>
                  }
                  @if (highlightedRowIndex === i) {
                    <div class="p-table-action-button-container">
                      @if (!isAppInWebViewContainer || canUseShoppingCart) {
                        <button
                          title="Mit Vermerk in den Warenkorb"
                          pRipple
                          type="button"
                          class="p-table-action-button"
                          id="{{ 'order-with-remark-' + i }}"
                          (click)="orderWithRemark($event, sequence, 'order-with-remark-' + i)"
                          >
                          <img src="assets/icons/order-with-remark.svg" alt="" />
                        </button>
                        <button
                          title="In den Warenkorb"
                          pRipple
                          type="button"
                          class="p-table-action-button"
                          id="{{ 'add-to-cart-' + i }}"
                          (click)="addToShoppingCart($event, sequence, 'add-to-cart-' + i)"
                          >
                          <img src="assets/icons/shopping-cart-white.svg" alt="In den Warenkorb" />
                        </button>
                      }
                      @if (isAppInWebViewContainer && canUseDocSet) {
                        <div class="break"></div>
                        <button
                          data-no-search
                          title="In das Docset"
                          pRipple
                          type="button"
                          class="p-table-action-button"
                          id="{{ 'add-to-docset-' + i }}"
                          (click)="addToDocSet($event, sequence, 'add-to-docset-' + i)"
                          >
                          <img src="assets/icons/docset.svg" alt="" />
                        </button>
                      }
                    </div>
                  }
                </td>
              }
            </tr>
          </ng-template>
        </p-table>
      </ng-container>
    }
    @if (tableRows && tableRows.length === 0 && !loading) {
      <div class="no-details-content">
        <div>
          <img src="assets/images/empty-state.svg" alt="" />
        </div>
        <div class="no-details-text-title">
          <div><img class="no-details-warning-icon" src="/assets/icons/warning-icon.svg" alt="" /></div>
          <div>Keine Sequenzen</div>
        </div>
      </div>
    }
    @if (loading) {
      <div class="loading-container">
        <p-progressSpinner strokeWidth="2" animationDuration="5s" styleClass="custom-spinner"></p-progressSpinner>
      </div>
    }
  </ng-container>
